
<div>
  <mat-card>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
      <!-- Filter -->
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true" class="mt-3">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ 'record_management_moha.dossier_management' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form class="pb-3" #filterForm="ngForm" (ngSubmit)="applyFilter()">
            <div class="filter-grid">
              <mat-form-field>
                <mat-label>{{'record_management_moha.contract_id' | translate}}</mat-label>
                <input matInput name="contractId" [(ngModel)]="filters.contractId" (focusout)="focusOutContractId()"
                  maxlength="255" autocomplete="off">
                <button mat-button matSuffix mat-icon-button type="button"
                  [attr.aria-label]="'record_management_moha.clear_contract_id' | translate" *ngIf="filters.contractId"
                  (click)="clearFilter('contractId')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
      
              <mat-form-field>
                <mat-label>{{'record_management_moha.employee' | translate}}</mat-label>
                <input matInput name="employee" [(ngModel)]="filters.employee" (focusout)="focusOutEmployee()"
                  maxlength="255"
                  autocomplete="off">
                <button mat-button matSuffix mat-icon-button type="button"
                  [attr.aria-label]="'record_management_moha.clear_employee' | translate" *ngIf="filters.employee"
                  (click)="clearFilter('employee')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{'record_management_moha.dossier_moha_send_status' | translate}}</mat-label>
                <mat-select name="dossierStatus" 
                            [(ngModel)]="filters.dossierStatus"
                            (selectionChange)="loadData()">
                  <mat-option [value]="''">
                    {{'form.select_all' | translate}}
                  </mat-option>
                  <!-- các option khác -->
                </mat-select>
              </mat-form-field>
              
              <mat-form-field>
                <mat-label>{{'record_management_moha.document_moha_send_status' | translate}}</mat-label>
                <mat-select name="documentStatus" 
                            [(ngModel)]="filters.documentStatus"
                            (selectionChange)="loadData()">
                  <mat-option [value]="''">
                    {{'form.select_all' | translate}}
                  </mat-option>
                  <!-- các option khác -->
                </mat-select>
              </mat-form-field>
        
              <mat-form-field>
                <mat-label>{{'record_management_moha.contract_document_code_name' | translate}}</mat-label>
                <input matInput name="nameOrCode" [(ngModel)]="filters.nameOrCode" (focusout)="focusOutNameOrCode()"
                  maxlength="255"
                  autocomplete="off">
                <button mat-button matSuffix mat-icon-button type="button"
                  [attr.aria-label]="'record_management_moha.clear_code_or_name' | translate" *ngIf="filters.nameOrCode"
                  (click)="clearFilter('nameOrCode')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="row mt-3">
              <div class="col-lg-12 d-flex justify-content-center">
                <button mat-stroked-button color="primary" type="submit" appTrackEvent="w.btn.hdbohoso.tim_kiem"
                  [disabled]="!filterForm.valid || loading">
                  <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                  {{'enterprise_contract.buttons.search' | translate}}
                </button>
              </div>
            </div>
          </form>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true" class="mt-3">
          <mat-panel-title class="mat-panel-title mb-2 pb-3 mt-3 d-flex align-items-center list-title-mine ">
            <div class="row">
              <div class="col-12"><span class="">{{'record_management_moha.labor_contract_package_list' | translate}}
                ({{ resultTotal }})
              </span></div>
            </div>
            <!-- <div class="buttonMD">
              <button class="btn1-mine" style="position: absolute; right: 24px" mat-stroked-button color="primary"
                type="button" (click)="onAddDocument()" appTrackEvent="w.btn.hdtoilap.them_moi"
              >
                <mat-icon class="mr-0">add_circle</mat-icon>
                {{'button.add' | translate}}
              </button>
            </div> -->
          </mat-panel-title>
          <div class="mat-table-container table-container example-container dossier-table-container">
            <mat-progress-bar *ngIf="loading" mode="indeterminate"
              [attr.aria-label]="'record_management_moha.loading_employee_list' | translate"></mat-progress-bar>
      
            <mat-table [dataSource]="dataSource" class="mat-table-col-extra-sm mat-table table dossier-table">
              <!-- <ng-container matColumnDef="check">
                <mat-header-cell *matHeaderCellDef
                  class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                  <mat-checkbox color="primary" [checked]="allVisibleSelected"
                    (change)="toggleAll($event.checked)" aria-label="Chọn tất cả bộ hợp đồng"></mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row"
                  class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                  (click)="$event.stopPropagation()">
                  <mat-checkbox *ngIf="row.type === 'dossier'" color="primary"
                    [checked]="isSelected(row.dossier)" (change)="toggleDossier(row.dossier, $event.checked)"
                    [attr.aria-label]="'Chọn bộ hợp đồng ' + (row.dossier.mohaId || row.number)">
                  </mat-checkbox>
                </mat-cell>
              </ng-container> -->
      
              <ng-container matColumnDef="expand">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center expand-col mat-cell-non-boder-right-bottom">
                </mat-header-cell>
                <mat-cell *matCellDef="let row" class="mat-header-cell-center expand-col mat-cell-non-boder-right-bottom">
                  <button *ngIf="row.type === 'dossier'" mat-icon-button type="button" class="expand-button"
                    [disabled]="!row.dossier.documents || row.dossier.documents.length === 0"
                    [attr.aria-expanded]="isExpanded(row.dossier)" (click)="toggleExpanded(row.dossier)">
                    <mat-icon>{{ isExpanded(row.dossier) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="STT">
                <mat-header-cell *matHeaderCellDef
                  class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">{{'record_management_moha.stt' |
                  translate}}</mat-header-cell>
                <mat-cell *matCellDef="let row" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                  <span *ngIf="row.type === 'dossier'">{{ row.number }}</span>
                  <mat-icon *ngIf="row.type === 'document'" class="hierarchy-icon">subdirectory_arrow_right</mat-icon>
                </mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="mohaUuid">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'record_management_moha.contract_id' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let row" class="mat-cell-non-boder-right-bottom id-cell"
                  [matTooltip]="row.type === 'dossier' ? row.dossier.mohaId : row.document.mohaId">
                  <span class="fix-width">
                    {{ (row.type === 'dossier' ? row.dossier.mohaId : row.document.mohaId) || '' }}
                  </span>
                </mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="nameAndCode">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'record_management_moha.contract_code_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let row" class="mat-cell-non-boder-right-bottom"
                  [matTooltip]="row.type === 'dossier' ? row.dossier.nameAndCode : row.document.contractName">
                  <span class="fix-width">
                    {{ row.type === 'dossier' ? row.dossier.nameAndCode : row.document.contractCode }}
                  </span>
                </mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="customerCode">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'record_management_moha.employee_code' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let row" class="mat-cell-non-boder-right-bottom"
                [matTooltip]="row.type === 'dossier' ? row.dossier.customerCode : row.document.customerCode">
                  <span class="fix-width">
                    {{ row.type === 'dossier' ? row.dossier.customerCode : row.document.customerCode }}
                  </span>
                </mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="employeeName">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'record_management_moha.employee_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let row" class="mat-cell-non-boder-right-bottom"
                  [matTooltip]="row.type === 'dossier' ? row.dossier.employeeName : row.document.employeeName">
                  <span class="fix-width">
                    {{ row.type === 'dossier' ? row.dossier.employeeName : row.document.employeeName }}
                  </span>
                </mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="certificateNo">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'record_management_moha.certificate_no' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let row" class="mat-cell-non-boder-right-bottom number-cell-center"
                  [matTooltip]="row.type === 'dossier' ? row.dossier.certificateNo : row.document.certificateNo">
                  <span class="fix-width">
                    {{ row.type === 'dossier' ? row.dossier.certificateNo : row.document.certificateNo }}
                  </span>
                </mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'record_management_moha.platform_send_status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let row" class="mat-header-cell-center mat-cell-non-boder-right-bottom status-cell">
                  <ng-container *ngIf="row.type === 'dossier'">
                    <nz-tag *ngIf="row.dossier.status === 'completed-all'" [nzColor]="'green'" style="margin-right: 0px;">
                      {{'record_management_moha.status.completed_all' | translate}}
                    </nz-tag>
                    <nz-tag *ngIf="row.dossier.status !== 'completed-all'" style="margin-right: 0px;">
                      {{'record_management_moha.status.incomplete_all' | translate}}
                    </nz-tag>
                  </ng-container>
                  <ng-container *ngIf="row.type === 'document'">
                    <nz-tag *ngIf="row.document.status === 'not-sent'" style="margin-right: 0px;">
                      {{'contract_terminate.no_send' | translate}}</nz-tag>
                    <nz-tag *ngIf="row.document.status === 'processing'" [nzColor]="'blue'" style="margin-right: 0px;">
                      {{'contract_terminate.sending' | translate}}</nz-tag>
                    <nz-tag *ngIf="row.document.status === 'failed'" [nzColor]="'red'" style="margin-right: 0px;">
                      {{'sign_contract_flow.error' | translate}}</nz-tag>
                    <nz-tag *ngIf="row.document.status === 'completed'" [nzColor]="'green'" style="margin-right: 0px;">
                      {{'contract_terminate.sent' | translate}}
                    </nz-tag>
                  </ng-container>
                </mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col">{{'record_management_moha.action'
                  | translate}}</mat-header-cell>
                <mat-cell *matCellDef="let row" class="number-cell-center action-col" (click)="$event.stopPropagation()">
                  <ng-container *ngIf="row.type === 'dossier'">
                    <!-- <button mat-icon-button type="button" class="action-button action-button--send"
                      [matTooltip]="'record_management_moha.direct_push' | translate" (click)="emitAction('push', row.dossier)">
                      <mat-icon>send</mat-icon>
                    </button> -->
                    <!-- <button mat-icon-button type="button" class="action-button action-button--view"
                      [matTooltip]="'record_management_moha.download' | translate" (click)="downloadContract(row.dossier)">
                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M15.75 10.75V11.75C15.75 13.1501 15.75 13.8502 15.4775 14.385C15.2378 14.8554 14.8554 15.2378 14.385 15.4775C13.8502 15.75 13.1501 15.75 11.75 15.75H4.75C3.34987 15.75 2.6498 15.75 2.11502 15.4775C1.64462 15.2378 1.26217 14.8554 1.02248 14.385C0.75 13.8502 0.75 13.1501 0.75 11.75V10.75M4.08333 6.58333L8.25 10.75L12.4167 6.58333M8.25 10.75V0.75"
                          stroke="#4C515B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
      
                    </button> -->
                    <button mat-icon-button type="button" (click)="downloadContracts(row.dossier)"
                      appTrackEvent="w.btn.hdtoilap.tai_file">
                      <mat-icon matTooltip="{{'record_management_moha.download_dossier' | translate}}">save_alt
                      </mat-icon>
                    </button>
                    <button mat-icon-button type="button" class="action-button action-button--danger"
                      [matTooltip]="'record_management_moha.link_appendix' | translate"
                      (click)="assignAppendix(row.dossier)">
                      <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.16699 0.75C13.7552 0.750193 17.583 4.82872 17.583 10C17.583 15.1713 13.7552 19.2498 9.16699 19.25C4.57869 19.25 0.75 15.1714 0.75 10C0.75 4.8286 4.57869 0.75 9.16699 0.75Z"
                          stroke="#CE002B" stroke-width="1.5" />
                        <path d="M9.16667 6V14M5.5 10H12.8333" stroke="#CE002B" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
      
                    </button>
                  </ng-container>
      
                  <ng-container *ngIf="row.type === 'document'">
                    <!-- <button mat-icon-button type="button" class="action-button action-button--view"
                      [matTooltip]="'record_management_moha.view_detail' | translate"
                      (click)="viewDetail(row.dossier, row.document)">
                      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M0.969894 7.17765C0.856405 6.99795 0.79966 6.9081 0.767895 6.76951C0.744035 6.66542 0.744035 6.50125 0.767895 6.39715C0.79966 6.25857 0.856405 6.16872 0.969893 5.98902C1.90773 4.50403 4.69929 0.75 8.95346 0.75C13.2076 0.75 15.9992 4.50403 16.937 5.98902C17.0505 6.16872 17.1073 6.25857 17.139 6.39715C17.1629 6.50125 17.1629 6.66542 17.139 6.76951C17.1073 6.9081 17.0505 6.99795 16.937 7.17765C15.9992 8.66263 13.2076 12.4167 8.95346 12.4167C4.69929 12.4167 1.90773 8.66263 0.969894 7.17765Z"
                          stroke="#4C515B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M8.95346 9.08333C10.3342 9.08333 11.4535 7.96405 11.4535 6.58333C11.4535 5.20262 10.3342 4.08333 8.95346 4.08333C7.57275 4.08333 6.45346 5.20262 6.45346 6.58333C6.45346 7.96405 7.57275 9.08333 8.95346 9.08333Z"
                          stroke="#4C515B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
      
                    </button> -->
                    <button mat-icon-button type="button"  matTooltip="{{'enterprise_contract.tooltips.document_view' | translate}}" (click)="viewDetail(row.dossier, row.document)">
                      <mat-icon>
                        visibility
                      </mat-icon>
                    </button>
                    <!-- <button mat-icon-button type="button" class="action-button action-button--view"
                      [matTooltip]="'record_management_moha.download' | translate"
                      (click)="downloadContract(row.dossier, row.document)">
                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M15.75 10.75V11.75C15.75 13.1501 15.75 13.8502 15.4775 14.385C15.2378 14.8554 14.8554 15.2378 14.385 15.4775C13.8502 15.75 13.1501 15.75 11.75 15.75H4.75C3.34987 15.75 2.6498 15.75 2.11502 15.4775C1.64462 15.2378 1.26217 14.8554 1.02248 14.385C0.75 13.8502 0.75 13.1501 0.75 11.75V10.75M4.08333 6.58333L8.25 10.75L12.4167 6.58333M8.25 10.75V0.75"
                          stroke="#4C515B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
      
                    </button> -->
                    <button mat-icon-button type="button" (click)="downloadContract(row.document)"
                      appTrackEvent="w.btn.hdtoilap.tai_file">
                      <mat-icon matTooltip="{{'enterprise_contract.buttons.download' | translate}}">save_alt
                      </mat-icon>
                    </button>
                    <!-- <button  class="action-button action-button--danger" [disabled]="!row.document.isCheckStandardized" mat-icon-button type="button"
                      matTooltip="{{ 'record_management_moha.unlink_appendix' | translate }}"
                      (click)="deleteAppendix(row.dossier, row.document)">
                      <i
                        nz-icon
                        [ngClass]="{
                          'disabled-locked': !row.document.isCheckStandardized
                        }"
                        class="fa fa-trash"
                        style="font-size: 20px"
                        aria-hidden="true"
                      ></i>
                    </button> -->
                    <button
                      mat-icon-button
                      type="button"
                      (click)="deleteAppendix(row.dossier, row.document)"
                      [disabled]="!row.document.isCheckStandardized"
                    >
                      <i
                        [ngClass]="{
                          'disabled-locked': !row.document.isCheckStandardized
                        }"
                        class="fa fa-trash"
                        style="font-size: 20px"
                        aria-hidden="true"
                        matTooltip="{{ 'record_management_moha.unlink_appendix' | translate }}"
                      ></i>
                    </button>
                  </ng-container>
                </mat-cell>
              </ng-container>
      
              <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"
                [class.dossier-row]="row.type === 'dossier'" [class.document-row]="row.type === 'document'">
              </mat-row>
            </mat-table>
      
          </div>
      
          <app-pagination [(paginate)]="paginate" (pageChange)="loadData($event.page, $event.pageSize)">
          </app-pagination>
        </mat-expansion-panel>
      </mat-accordion>


    </mat-card-content>
  </mat-card>
</div>
